"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const Delete = _ref => {
  let {
    title = 'Delete',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.313 7.969v2.688h-18.625v-2.688h4.625l1.375-1.313h6.625l1.375 1.313h4.625zM8 27.969v-16h16v16q0 1.063-0.813 1.875t-1.875 0.813h-10.625q-1.063 0-1.875-0.813t-0.813-1.875z"
  }));
};
var _default = exports.default = (0, _ikon.default)(Delete);
Delete.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Delete",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Delete'",
        "computed": false
      },
      "required": false
    }
  }
};